import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarCheck,
  faBullhorn,
  faPaintBrush,
  faStarHalfAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./App.css";

const services = [
  {
    title: "Event Management",
    description:
      "Pengelolaan acara profesional dari konsep hingga pelaksanaan, dengan fokus pada detail dan pengalaman peserta.",
    icon: faCalendarCheck,
    link: "/Kontak",
  },
  {
    title: "Digital Marketing",
    description:
      "Strategi pemasaran digital komprehensif untuk meningkatkan visibilitas dan engagement brand Anda.",
    icon: faBullhorn,
    link: "/Kontak",
  },
  {
    title: "Creative Content",
    description:
      "Produksi konten kreatif yang menarik dan sesuai dengan identitas brand Anda.",
    icon: faPaintBrush,
    link: "/Kontak",
  },
  {
    title: "Brand Development",
    description:
      "Pengembangan brand yang kuat dan konsisten untuk membangun kepercayaan pelanggan.",
    icon: faStarHalfAlt,
    link: "/Kontak",
  },
];

const Beranda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen text-center text-cyan-600 flex-col justify-center relative bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4 py-20">
        <>
          <motion.h2
            className="text-base sm:text-lg md:text-xl font-normal uppercase mb-1 md:mb-2 text-cyan-600"
            initial={{ opacity: 0, y: -15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            PT CAKRAWALA JAKARTA KREATIF
          </motion.h2>

          <motion.p
            className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black mx-auto mb-8 md:mb-16 text-cyan-600 px-4"
            initial={{ opacity: 0, y: -15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            LAYANAN KAMI
          </motion.p>

          <div className="max-w-6xl mx-auto space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              {services.map((service, index) => (
                <motion.div
                  key={service.title}
                  className="bg-white rounded-xl p-4 border border-slate-200"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <FontAwesomeIcon
                    icon={service.icon}
                    className="text-4xl mb-4 text-cyan-600"
                  />
                  <h3 className="text-xl font-bold text-cyan-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-cyan-800 mb-6">{service.description}</p>
                  <Link
                    to={service.link}
                    className="inline-block bg-cyan-600 text-white px-6 py-2 rounded-xl hover:bg-cyan-700 transition-colors duration-200"
                  >
                    Pelajari Lebih Lanjut
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </>
      </div>
    </section>
  );
};

export default Beranda;
